import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { Row, Col } from 'reactstrap';

import * as abonadosActions from 'modules/abonados/action';
import { EliminarConfirmacionC } from 'modules/general/component';

/*
Props:

abono
*/

@connect((store) => ({
  abonado: store.getIn(['abonados', 'abonado']),
  eliminarId: store.getIn(['abonados', 'eliminarId']),
}))
export default class extends React.Component {
  eliminarAbono = () => {
    this.props.dispatch(abonadosActions.deleteAbono(this.props.eliminarId));
    this.props.dispatch(abonadosActions.setState({ eliminarId: false }));
  };
  confirmarEliminar = (abonoId) => this.props.dispatch(abonadosActions.setState({ eliminarId: abonoId ? abonoId : false }));
  render() {
    const { abono, eliminarId } = this.props;

    return (
      <div>
        <MaterialUI.ListItem
          disabled
          primaryText={
            <Row>
              <Col md="4">
                <b>Fecha de pago:</b> {moment(abono.get('fechaCreado')).format('DD/MM/YY')}
              </Col>
              <Col md="4">
                <b>Fecha alta abono:</b> {moment(abono.get('fechaDesde')).format('DD/MM/YY')}
              </Col>
              <Col md="4">
                <b>Vencimiento:</b> {moment(abono.get('fechaHasta')).format('DD/MM/YY')}
              </Col>
            </Row>
          }
          rightIconButton={<MaterialUI.FlatButton icon={<FontAwesome className="iconBar red" name="trash" />} onTouchTap={() => this.confirmarEliminar(abono.get('id'))} className="listIcon" />}
        />
        <EliminarConfirmacionC
          eliminarId={eliminarId}
          cancelar={this.confirmarEliminar}
          confirmar={this.eliminarAbono}
          content={'Las reservas automaticas del usuario deberan ser eliminadas manualmente (en caso de ser necesario)'}
        />
        <MaterialUI.Divider />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/abonados/components/abonoItemList.js